import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const RefreshIcon = ({tintColor = '#fff', ...props}) => {
  return (
    <Svg
      width={50}
      height={62}
      viewBox="0 0 50 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M24.632 11.003a20 20 0 00-11.61 36.02 2.4 2.4 0 11-2.88 3.84A24.8 24.8 0 0122.91 6.285l-1.869-1.875a2.4 2.4 0 013.392-3.392l6.79 6.787a2.4 2.4 0 010 3.392l-6.79 6.794a2.398 2.398 0 01-3.98-.737 2.398 2.398 0 01.588-2.655l3.59-3.6v.003zm.736 39.994a20 20 0 0011.61-36.02 2.4 2.4 0 112.88-3.84A24.8 24.8 0 0127.09 55.715l1.868 1.872a2.4 2.4 0 01-3.392 3.395l-6.79-6.788a2.4 2.4 0 010-3.392l6.79-6.79a2.401 2.401 0 013.948 2.613c-.13.294-.32.56-.556.78l-3.59 3.593z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default RefreshIcon;
